import '~/js/modules/section-hero';
import ToursList from '~/js/components/tours/ToursList';
import Spinner from '~/js/components/general/Spinner';
import GoFetch from '~/js/modules/fetch-wrapper.js';
import '~/js/libs/jquery-ui.selectmenu.min.js';

const fetch = new GoFetch();
const $resortSelect = $('#js-resort-select');
const toursList = document.getElementById('tours-list');
const spinnerHolder = document.getElementById('spinner-holder');

const { resorts } = window.beaches_app.page;

//Slider Code
document.querySelector(".prevBtn").addEventListener("click", () => {
  changeSlides(-1);
});
document.querySelector(".nextBtn").addEventListener("click", () => {
  changeSlides(1);
});
var slideIndex = 1;
showSlides(slideIndex);
function changeSlides(n) {
  showSlides((slideIndex += n));
}

window.currentSlide= currentSlide;

function currentSlide(n) {
  showSlides((slideIndex = n));
}
function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("Slide");
  var dots = document.getElementsByClassName("Navdot");
  if (n > slides.length) {
     slideIndex = 1;
  }
  if (n < 1) {
     slideIndex = slides.length;
  }
  Array.from(slides).forEach(item => (item.style.display = "none"));
  Array.from(dots).forEach(
     item => (item.className = item.className.replace(" selected", ""))
  );
  slides[slideIndex - 1].style.display = "block";
  dots[slideIndex - 1].className += " selected";
}
//End SliderCode

//DRAGGABLE SLIDER

//END DRAGGABLE SLIDER

const loadResort = {
  value: sessionStorage.getItem('loadResortCode') || $resortSelect.val(),
  label: sessionStorage.getItem('loadResortName') || $(':selected', $resortSelect).text()
};

const selectHandler = (event, {item}) => {
  const element = item || loadResort;

  $(toursList).removeClass('loaded');
  sessionStorage.removeItem('loadResortCode');
  sessionStorage.removeItem('loadResortName');

  if(element && element.value && element.label) {
    ReactDOM.unmountComponentAtNode(toursList);
    ReactDOM.render(<Spinner />, spinnerHolder);

    fetch.post('/events/fetchTours/', null, {
      rstCode: element.value
    }).then((response) => {
      ReactDOM.unmountComponentAtNode(spinnerHolder);
      ReactDOM.render(<ToursList data={response.data.events} resortName={element.label} />, toursList);
      $(toursList).addClass('loaded');
    }).catch((error) => {
      console.error(error);
    });
  }
};

if(loadResort && loadResort.value) {
  $resortSelect.val(loadResort.value.toUpperCase());
  window.scrollTo(0, $resortSelect.offset().top + 40);
}

$resortSelect.selectmenu({
  select: selectHandler,
  create: selectHandler
});

$(window).on('resize', ()=>{
  $resortSelect.selectmenu('close');
});

$(window).on('click touchstart', (event)=>{
  if (!$(event.target).closest('.ui-selectmenu-menu').length && !$(event.target).closest('.ui-selectmenu-button').length) {
    $resortSelect.selectmenu('close');
  }
});

$(document).ready( () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const defaultResortCode = urlParams.get('resort'); // Add resort as urlParams BNG

  const resortCode = urlParams.get('rstCode');
  if (resortCode != null) {
    $resortSelect.val(resortCode);

    const $toursListContainer = $('.tours-list-container');
    window.focus();
    window.scrollTo(0, $toursListContainer.offset().top);

    var temp = document.getElementsByClassName('ui-selectmenu-text');
    while( temp[0].firstChild ) {
      temp[0].removeChild( temp[0].firstChild );
    }
    
    let selectOption = resorts.find(resortObject => resortObject.code === resortCode);

    temp[0].appendChild(document.createTextNode(selectOption.name));

    $(toursList).removeClass('loaded');

    ReactDOM.unmountComponentAtNode(toursList);
    ReactDOM.render(<Spinner />, spinnerHolder);

    fetch.post('/events/fetchTours/', null, {
      rstCode: resortCode
    }).then((response) => {
      ReactDOM.unmountComponentAtNode(spinnerHolder);
      ReactDOM.render(<ToursList data={response.data.events} resortName={selectOption.name} />, toursList);
      ReactDOM.render(<ToursList defaultResortCode={defaultResortCode} />, toursList); // Add items to defaultResortCode BNG
      $(toursList).addClass('loaded');
    }).catch((error) => {
      console.error(error);
    });
  }

  if(defaultResortCode != null && resortCode == null){
 
    $resortSelect.val(defaultResortCode);
 
    const $toursListContainer = $('.tours-list-container');
    window.focus();
    window.scrollTo(0, $toursListContainer.offset().top);
 
    var temp = document.getElementsByClassName('ui-selectmenu-text');
    while( temp[0].firstChild ) {
      temp[0].removeChild( temp[0].firstChild );
    }
    
    let selectOption = resorts.find(resortObject => resortObject.code === defaultResortCode);
    console.log(selectOption)
 
    temp[0].appendChild(document.createTextNode(selectOption.name));
 
    $(toursList).removeClass('loaded');
 
    ReactDOM.unmountComponentAtNode(toursList);
    ReactDOM.render(<Spinner />, spinnerHolder);
 
    fetch.post('/events/fetchTours/', null, {
      rstCode: defaultResortCode
    }).then((response) => {
      ReactDOM.unmountComponentAtNode(spinnerHolder);
      ReactDOM.render(<ToursList data={response.data.events} resortName={selectOption.name} />, toursList);
      $(toursList).addClass('loaded');
    }).catch((error) => {
      console.error(error);
    });
 
  }
});
